import { NavLink } from "react-router-dom";

export default function AdminSidebar({ sidebarOpen, setSidebarOpen }) {
  const linkClass = ({ isActive }) =>
    `block w-full px-4 py-2 rounded transition-all duration-200 text-sm font-medium ${
      isActive
        ? "bg-orange-500 text-slate-950"
        : "text-slate-700 hover:bg-orange-100 hover:text-orange-600"
    }`;

  const navLinks = [
    { name: "Dashboard", path: "/admin/dashboard" },
    { name: "Categories", path: "/admin/categories" },
    { name: "Products", path: "/admin/products" },
    { name: "Orders", path: "/admin/orders" },
    // { name: "Users", path: "/admin/users" },
    // { name: "Coupons", path: "/admin/coupons" },
    // { name: "Returns", path: "/admin/returns" },
    // { name: "Reviews", path: "/admin/reviews" },
    // { name: "Carts", path: "/admin/carts" },
    { name: "Payment Settings", path: "/admin/settings/payment" },
  ];

  return (
    <>
      {sidebarOpen && (
        <div
          className="fixed top-20 inset-x-0 bottom-0 bg-orange-100/40 z-40 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <aside
        className={`fixed md:sticky top-20 md:top-20 left-0 z-50 h-[calc(100vh-5rem)] w-64 bg-[#fff4e6] border-r border-orange-200 flex flex-col transform transition-transform duration-300 ease-in-out ${
          sidebarOpen ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0`}
      >
        {/* <div className="p-4 border-b border-gray-700 shrink-0">
          <h2 className="text-xl font-bold text-white tracking-wide">
            Admin Panel
          </h2>
        </div> */}

        <nav className="flex-1 overflow-y-auto p-4 space-y-2">
          {navLinks.map((link) => (
            <NavLink
              key={link.name}
              to={link.path}
              onClick={() => setSidebarOpen(false)}
              className={linkClass}
            >
              {link.name}
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-gray-700 shrink-0">
          <NavLink
            to="/adminlogin"
            onClick={() => {
              localStorage.removeItem("adminToken");
              localStorage.removeItem("adminEmail");
              setSidebarOpen(false);
            }}
            className={linkClass}
          >
            Logout
          </NavLink>
        </div>
      </aside>
    </>
  );
}